import type { TableColumnsType } from 'antd'
import { Table } from 'antd'
import moment from 'moment/moment'
import { IconButton } from '@mui/material'
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye'
import { IAiAgent, IDashboardRule } from '../../interfaces'
import React from 'react'


interface ITableAiAgents {
  data: IAiAgent[],
  sortFunction: any
}

const TableAiAgents: React.FC<ITableAiAgents> = ({ data, sortFunction }) => {
  const columns: TableColumnsType<IAiAgent> = [
    {
      title: 'Id',
      dataIndex: 'id',
      sorter: true,
      defaultSortOrder: 'ascend',
      key: 'id'
    },

    {
      title: 'Nome',
      sorter: true,
      key: 'Name',
      render: (_, record) => record.name
    },

    {
      title: 'Origem',
      key: 'Origem',
      render: (_, record) => record.snowflakeAgent
        ? <span>Snowflake <span style={{ color: '#6b7a80', fontSize: 12 }}>{record.snowflakeDatabase}.{record.snowflakeSchema}.{record.snowflakeAgent}</span></span>
        : <span>Fabric <span style={{ color: '#6b7a80', fontSize: 12 }}>(legado)</span></span>
    },

    {
      title: 'Ações',
      render: (_, record) =>
        <div className="justify-end">
          <IconButton
            size="small" aria-label="editar usuário" component="label"
            onClick={() => window.location.href = `/app/dash_management/agents/${record.id}`}
            //disabled={promiseInProgress}
          >
            <RemoveRedEyeIcon fontSize="small" />
          </IconButton>
        </div>
    }
  ]


  const handleChange = (pagination: any, filters: any, sorter: any) => {
    sortFunction(sorter)
  }

  return (
    <>
      <Table
        locale={{
          triggerDesc: 'Ordenação descendente',
          triggerAsc: 'Ordenação ascendente',
          cancelSort: 'Cancelar ordenação',
          emptyText: 'Nenhum agente'
        }}
        pagination={false}
        columns={columns}
        rowKey={(record) => record.id!.toString()}
        onChange={handleChange}
        dataSource={data}
      />

    </>
  )
}


export default TableAiAgents